import { Component, Inject, NgZone, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { catchError, map, throwError } from "rxjs";
import { ProfileService } from "src/app/modules/myVirsa/services/profile.service";
import { PaymentService } from "src/app/services/payment.service";
import { transform } from "src/app/utils/date-utils";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-razorpay",
  templateUrl: "./razorpay.component.html",
  styleUrls: ["./razorpay.component.scss"],
})
export class RazorpayComponent implements OnInit {
  paymentResponse: any;
  profile_data: any;
  msg = "Payment Faild";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private winRef: PaymentService,
    private pay: PaymentService,
    private profile: ProfileService,
    private ngZone: NgZone,
    private ref: MatDialogRef<RazorpayComponent>
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  payWithRazor(val: string) {
    const options: any = {
      key: environment.RAZORPAY_KEY_ID,
      amount: "", // amount should be in paise format to display Rs 1255 without decimal point
      currency: "INR",
      name: transform(
        this.profile_data.user.first_name +
          " " +
          this.profile_data.user.last_name
      ), // company name or product name
      description: "web Reference No. #" + val, // product description
      image: "https://s3.amazonaws.com/rzp-mobile/images/rzp.png", // company logo or product image
      order_id: val, // order_id created by you in backend
      modal: {
        // We should prevent closing of the form when esc key is pressed.
        escape: false,
      },
      prefill: {
        name: transform(
          this.profile_data.user.first_name +
            " " +
            this.profile_data.user.last_name
        ),
        email: this.profile_data.user.email,
        contact: this.profile_data.mobile,
      },
      notes: {
        // include notes if any
      },
      theme: {
        color: "#0c238a",
      },
    };
    options.handler = (response: any) => {
      this.confirmPayment(response);
      // call your backend api to verify payment signature & capture transaction
    };
    options.modal.ondismiss = () => {
      // handle the case when user closes the form while transaction is in progress
      this.ngZone.run(() => {
        this.msg = "Payment Cancelled.";
      });
    };
    const rzp = new this.winRef.nativeWindow.Razorpay(options);
    rzp.open();
  }

  getData(): void {
    this.profile
      .getProfile()
      .pipe(
        map((res: any) => {
          this.profile_data = res.details;
          this.payWithRazor(this.data.id);
        }),
        catchError((error) => {
          return throwError(error.massage || error);
        })
      )
      .subscribe();
  }

  confirmPayment(response: any) {
    const body = {
      razorpay_order_id: response.razorpay_order_id,
      razorpay_payment_id: response.razorpay_payment_id,
      razorpay_signature: response.razorpay_signature,
    };
    this.pay
      .confirmPayment(body)
      .pipe(
        map((res: any) => {
          this.ngZone.run(() => {
            this.msg = res.message;
          });
        }),
        catchError((error) => {
          return throwError(error.massage || error);
        })
      )
      .subscribe();
  }
}
